import React, { useEffect, useState } from "react";
import { adminRequest } from "../../../utils/requestMethods";
import List from "../../../components/List/List";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL } from "../../../utils/config";
import Loader from "../../../components/Loader/Loader";
import NotFound from "../../../components/NotFound/NotFound";

const EnrollmentList = () => {
  const headers = ["Academic Year", "Enrollment Batch"];
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await adminRequest.get(
        `${BASE_URL}/enrollmentSetup/list`,
      );
      const fetchedRows = response.data.data.map((s) => ({
        displayData: [s.academicYear, s.enrollmentBatch],
        uuid: s.uuid,
      }));
      setRows(fetchedRows);
    } catch (error) {
      return <NotFound />;
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const getMenuItems = (row) => [{ link: `edit/${row.uuid}`, text: "Edit" }];

  return (
    <div className="enrollmentSetupListContainer">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <List
            title="Enrollment Setup List"
            createButtonLabel="Create Enrollment Setup"
            headers={headers}
            rows={rows.map((row) => row.displayData)}
            link="create"
            showEyeViewIcon={false}
            showFilterIcon={false}
            getMenuItems={(row) =>
              getMenuItems(rows.find((r) => r.displayData === row))
            }
          />
        </>
      )}
      <ToastContainer position="top-center" />
    </div>
  );
};

export default EnrollmentList;
